import { render } from "./typeEdit.vue?vue&type=template&id=6a803aae"
import script from "./typeEdit.vue?vue&type=script&lang=js"
export * from "./typeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__